import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #984a94;
  height: 56px;
  border-radius: 10px;
  border: 0;
  color: #d2d2d2;
  width: 100%;
  font-weight: 500;
  margin-top: 16px;
  transition: background-color 0.2s;
  &:hover {
    background: ${shade(0.2, '#984A99')};
  }
`;
